export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    news() {
      return this.$store.state.news.news;
    },
  },
  methods: {
    getPublication(id) {
      this.$store.dispatch('news/SetPublication', id);
      this.$router.push(`/publication/${id}`);
    },
  },
  created() {
    this.user.profile_id && this.$store.dispatch('news/GetNews', this.user.profile_id);
  },
};
